if (!customElements.get("card-variant-selection")) {
  class CardVariantSelection extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", this.onVariantChange);
    }

    onVariantChange(event) {
      this.updateOptions();
      this.updateMasterId();
      this.updateMedia();
      this.updateAddButton();
      this.updatePrice();
    }

    updatePrice() {
      if (!this.currentVariant || !this.dataset.url) return;
      const url = `${this.dataset.url}${
        this.dataset.url.includes("?") ? "&" : "?"
      }variant=${this.currentVariant.id}`;

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const newPriceSource =
            html.querySelector(".product__info-container .price") ||
            html.querySelector(".price");

          if (newPriceSource) {
            const currentCard = this.closest(".card");
            const currentPrice = currentCard
              ? currentCard.querySelector(".price")
              : null;

            if (currentPrice) {
              const newContainer =
                newPriceSource.querySelector(".price__container");
              const currentContainer =
                currentPrice.querySelector(".price__container");

              if (newContainer && currentContainer) {
                currentContainer.innerHTML = newContainer.innerHTML;
              }

              const modifiers = [
                "price--on-sale",
                "price--sold-out",
                "price--no-compare",
              ];
              modifiers.forEach((cls) => currentPrice.classList.remove(cls));

              modifiers.forEach((cls) => {
                if (newPriceSource.classList.contains(cls)) {
                  currentPrice.classList.add(cls);
                }
              });
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    updateOptions() {
      this.options = Array.from(
        this.querySelectorAll('input[type="radio"]:checked'),
        (input) => input.value
      );
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });

      const idInput = this.querySelector('input[name="id"]');
      if (this.currentVariant && idInput) {
        idInput.value = this.currentVariant.id;
      }
    }

    updateMedia() {
      if (!this.currentVariant || !this.currentVariant.featured_media) return;
      const card = this.closest(".card");
      if (!card) return;

      const media = card.querySelector(".card__media img");
      if (media) {
        // Simple src update - for a full implementation we'd need srcset/sizes or swap hidden images
        // But typically changing the main image src is enough for a quick effect
        media.src = this.currentVariant.featured_media.preview_image.src;
        media.srcset = ""; // Clear srcset to force src usage or rebuild it
      }
    }

    updateAddButton() {
      let addButton = this.querySelector('[name="add"]');
      if (!addButton && this.dataset.buttonId) {
        addButton = document.getElementById(this.dataset.buttonId);
      }

      if (!addButton) return;

      const iconWrap = addButton.querySelector(".icon-wrap");
      const soldOutMessage = addButton.querySelector(".sold-out-message");
      const textSpan = addButton.querySelector(".text");

      if (iconWrap && soldOutMessage) {
        if (!this.currentVariant) {
          addButton.setAttribute("disabled", "disabled");
          iconWrap.classList.add("hidden");
          soldOutMessage.textContent = window.variantStrings.unavailable;
          soldOutMessage.classList.remove("hidden");
          if (textSpan) textSpan.classList.add("hidden");
        } else if (!this.currentVariant.available) {
          addButton.setAttribute("disabled", "disabled");
          iconWrap.classList.add("hidden");
          soldOutMessage.textContent = window.variantStrings.soldOut;
          soldOutMessage.classList.remove("hidden");
          if (textSpan) textSpan.classList.add("hidden");
        } else {
          addButton.removeAttribute("disabled");
          iconWrap.classList.remove("hidden");
          soldOutMessage.classList.add("hidden");
          if (textSpan) {
            textSpan.classList.remove("hidden");
            textSpan.textContent = window.variantStrings.addToCart;
          }
        }
      } else if (textSpan) {
        if (!this.currentVariant) {
          addButton.setAttribute("disabled", "disabled");
          textSpan.textContent = window.variantStrings.unavailable;
        } else if (!this.currentVariant.available) {
          addButton.setAttribute("disabled", "disabled");
          textSpan.textContent = window.variantStrings.soldOut;
        } else {
          addButton.removeAttribute("disabled");
          textSpan.textContent = window.variantStrings.addToCart;
        }
      } else {
        if (!this.currentVariant) {
          addButton.setAttribute("disabled", "disabled");
          addButton.textContent = window.variantStrings.unavailable;
        } else if (!this.currentVariant.available) {
          addButton.setAttribute("disabled", "disabled");
          addButton.textContent = window.variantStrings.soldOut;
        } else {
          addButton.removeAttribute("disabled");
          addButton.textContent = window.variantStrings.addToCart;
        }
      }
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }

  customElements.define("card-variant-selection", CardVariantSelection);
}
